const formatDateYmd = (dateString: string): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const formatDateY = (dateString: string): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();

    return `${year}`;
}

const fomatDateTimeIndo = (dates: Date): string => {
    const dateObject = new Date(dates);
    // format to 12 Desember 2020 12:00

    const month = dateObject.toLocaleString('default', { month: 'long' });
    const date = dateObject.getDate();
    const year = dateObject.getFullYear();
    const hour = dateObject.getHours();
    const minute = dateObject.getMinutes();

    return `${date} ${month} ${year} ${hour}:${minute}`;
}

const formatDateIndo = (dates: Date): string => {
    const dateObject = new Date(dates);
    // format to 12 Desember 2020

    const month = dateObject.toLocaleString('default', { month: 'long' });
    const date = dateObject.getDate();
    const year = dateObject.getFullYear();

    return `${date} ${month} ${year}`;
}



export { formatDateYmd, formatDateY, fomatDateTimeIndo,formatDateIndo };
